var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNavQa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.638 20.276.626-.313-.626.313zm-.483-4.463-.634-.297.634.297zm-.125 3.247-.626.313.626-.313zM2.3 12c0 5.357 4.343 9.7 9.7 9.7v-1.4A8.3 8.3 0 0 1 3.7 12H2.3zM12 2.3c-5.357 0-9.7 4.343-9.7 9.7h1.4A8.3 8.3 0 0 1 12 3.7V2.3zm9.7 9.7c0-5.357-4.343-9.7-9.7-9.7v1.4a8.3 8.3 0 0 1 8.3 8.3h1.4zm-.911 4.11A9.665 9.665 0 0 0 21.7 12h-1.4c0 1.258-.28 2.45-.78 3.516l1.269.594zm-1.385 3.263.608 1.216 1.252-.626-.608-1.216-1.252.626zm.608 1.216a.2.2 0 0 1 .179-.289v1.4a1.2 1.2 0 0 0 1.073-1.737l-1.252.626zm.179-.289H12v1.4h8.191v-1.4zm-.67-4.784c-.538 1.148-.753 2.585-.117 3.857l1.252-.626c-.38-.762-.294-1.726.133-2.637l-1.268-.594z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9.612c0-1.317 1.28-2.351 2.732-2.064.849.166 1.537.815 1.717 1.61.231 1.036-.347 1.972-1.247 2.37-.579.258-.952.79-.952 1.39v1.332",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.25a.562.562 0 1 0 0-1.125.562.562 0 0 0 0 1.125z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavQa);
export default __webpack_public_path__ + "static/media/icon_nav_qa.3b23e0a7fcb6fe341b55bb13a79e265d.svg";
export { ForwardRef as ReactComponent };